import { useState, useEffect } from 'react';
import axios from 'axios';
import { BLOGS_ENDPOINT } from './constants/config';
import BackgroundGradient from './components/BackgroundGradient';
import Header from './components/Header';
import HeroSection from './components/HeroSection';
import SkillsSection from './components/SkillsSection';
import BlogFormModal from './components/BlogFormModal';
import BlogList from './components/BlogList';
import Footer from './components/Footer';

function App() {
  const [title, setTitle] = useState('');
  const [content, setContent] = useState('');
  const [blogs, setBlogs] = useState([]);
  const [showForm, setShowForm] = useState(false);

  useEffect(() => {
    fetchBlogs();
  }, []);

  const fetchBlogs = async () => {
    try {
      const res = await axios.get(BLOGS_ENDPOINT);
      setBlogs(res.data);
    } catch (error) {
      console.error('Failed to fetch blogs:', error);
    }
  };

  const saveBlog = async () => {
    if (!title.trim() || !content.trim()) {
      alert('Please fill in all fields');
      return;
    }
    try {
      await axios.post(BLOGS_ENDPOINT, { title, content });
      setTitle('');
      setContent('');
      setShowForm(false);
      fetchBlogs();
    } catch (error) {
      console.error('Failed to save blog:', error);
      alert('Failed to create blog. Please try again.');
    }
  };

  return (
    <div className="min-h-screen bg-black text-white overflow-hidden">
      <BackgroundGradient />

      <Header />

      <main className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <HeroSection />
        <SkillsSection />
        <BlogFormModal
          showForm={showForm}
          setShowForm={setShowForm}
          title={title}
          setTitle={setTitle}
          content={content}
          setContent={setContent}
          saveBlog={saveBlog}
        />
        <BlogList blogs={blogs} showForm={showForm} setShowForm={setShowForm} />
      </main>

      <Footer />

      <style jsx>{`
        @keyframes blob {
          0%, 100% { transform: translate(0, 0) scale(1); }
          33% { transform: translate(30px, -50px) scale(1.1); }
          66% { transform: translate(-20px, 20px) scale(0.9); }
        }
        .animate-blob {
          animation: blob 7s infinite;
        }
        .animation-delay-2000 {
          animation-delay: 2s;
        }
        .animation-delay-4000 {
          animation-delay: 4s;
        }
        @keyframes slideIn {
          from { width: 0; }
        }
        .line-clamp-3 {
          display: -webkit-box;
          -webkit-line-clamp: 3;
          -webkit-box-orient: vertical;
          overflow: hidden;
        }
      `}</style>
    </div>
  );
}

export default App;